
























































import { computed, defineComponent, getCurrentInstance, ref, toRefs } from '@vue/composition-api';
import { UserIcon } from 'tdesign-icons-vue';

import { collectInfoHandler } from '@/renderer/views/common/collect/compositions/collectInfoHandler';

import tips from '@/renderer/scripts/utils/tips';

export default defineComponent({
  components: { UserIcon },
  props: {
    collectToken: {
      type: String,
      require: true,
      default: '',
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;

    const {
      collectTask,
      orgLogoInfo,
      isExpire,
      isInvalid,
      methods: collectInfoMethods,
    } = collectInfoHandler(props.collectToken);
    const loading = ref(true);

    const methods = {
      async init() {
        if (props.collectToken) {
          try {
            loading.value = true;
            await collectInfoMethods.getCollectInfo();
            vm.$emit('setOrgLogoInfo', orgLogoInfo.value);
          } catch (e: MsgError) {
            tips.error(e);
          }
          loading.value = false;
        }
      },
      phoneVerify(way: string) {
        vm.$emit('show-login-dialog', way);
      },
    };
    methods.init();

    return { collectTask, orgLogoInfo, isExpire, isInvalid, loading, ...collectInfoMethods, ...methods };
  },
});
